import {SET_RESPONDENT} from '../actions/respondent'
import {RESET} from '../actions/survey'

const initialState = {
    id: null,
    name: '',
    email: '',
    age: null,
    position: '',
    phone: '',
    gender: null,
    country: '',
    experience: null,
    valid: false,
    finished: false,
};

const handleSetRespondent = (state, {respondent}) => ({
    ...state,
    ...respondent,
    valid: true // redux-form takes care of validation, this will not be triggered otherwise
});

const handleReset = (state, {finished}) => ({
    ...initialState,
    finished
});

export default (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case RESET:
            return handleReset(state, payload);
        case SET_RESPONDENT:
            return handleSetRespondent(state, payload);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/respondent.js